"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { useReducer, useMemo, useState, useCallback, useEffect } from "react";
import { s3DataService } from "../services/S3DataService";
import { transformer } from "../services/chartDataTransformer/transformer";
export const ALL_OPTION = { id: 0, name: "All" };
export const ALL_STATUSES_OPTION = { id: "0", name: "All" };
const formatStatusName = (statusName) => {
  return statusName.split("_").map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ");
};
const initialState = {
  dataSource: "",
  showAs: "",
  groupBy: "",
  dateRange: "last_12_months",
  selectedEntities: [ALL_OPTION],
  selectedStatuses: [ALL_STATUSES_OPTION]
};
function chartReducer(state, action) {
  switch (action.type) {
    case "SET_DATA_SOURCE":
      return __spreadProps(__spreadValues({}, state), {
        dataSource: action.payload,
        showAs: "",
        groupBy: "",
        selectedEntities: [ALL_OPTION]
      });
    case "SET_SHOW_AS":
      return __spreadProps(__spreadValues({}, state), {
        showAs: action.payload,
        groupBy: "",
        selectedEntities: [ALL_OPTION]
      });
    case "SET_GROUP_BY":
      return __spreadProps(__spreadValues({}, state), {
        groupBy: action.payload
      });
    case "SET_DATE_RANGE":
      return __spreadProps(__spreadValues({}, state), {
        dateRange: action.payload
      });
    case "SET_ENTITIES":
      return __spreadProps(__spreadValues({}, state), {
        selectedEntities: action.payload
      });
    case "SET_STATUSES":
      return __spreadProps(__spreadValues({}, state), {
        selectedStatuses: action.payload
      });
    case "SET_PRESET_FILTERS":
      return __spreadProps(__spreadValues({}, state), {
        dataSource: action.payload.dataSource,
        showAs: action.payload.showAs,
        groupBy: action.payload.groupBy,
        dateRange: action.payload.dateRange,
        selectedEntities: [ALL_OPTION]
      });
    case "RESET":
      return initialState;
    default:
      return state;
  }
}
export function useChartData(entities) {
  const [state, dispatch] = useReducer(chartReducer, initialState);
  const { dataSource, showAs, groupBy, dateRange, selectedEntities, selectedStatuses } = state;
  const [downloadProgress, setDownloadProgress] = useState({
    total: 0,
    completed: 0,
    percentage: 0,
    status: "idle"
  });
  const [downloadedData, setDownloadedData] = useState(null);
  const [initialLoadAttempted, setInitialLoadAttempted] = useState(false);
  const availableStatuses = useMemo(() => {
    if (!downloadedData || dataSource !== "applications" && dataSource !== "jobs") {
      return [ALL_STATUSES_OPTION];
    }
    const statuses = /* @__PURE__ */ new Set();
    Object.entries(downloadedData).forEach(([key, value]) => {
      if (Array.isArray(value.data)) {
        value.data.forEach((record) => {
          if (record.status) {
            statuses.add(record.status);
          }
        });
      }
    });
    return [
      ALL_STATUSES_OPTION,
      ...Array.from(statuses).map((status) => ({ id: status, name: formatStatusName(status) }))
    ];
  }, [downloadedData, dataSource]);
  const downloadPastYearData = useCallback(
    (selectedEntities2) => __async(this, null, function* () {
      if (!dataSource || !["applications", "jobs"].includes(dataSource) || !selectedEntities2.length) {
        return;
      }
      const currentStatus = downloadProgress.status;
      if (currentStatus === "downloading" || currentStatus === "processing") {
        console.log("Download already in progress, ignoring request");
        return;
      }
      setDownloadProgress({
        total: 0,
        completed: 0,
        percentage: 0,
        status: "downloading"
      });
      try {
        const entityIds = selectedEntities2.filter((entity) => entity.id !== 0).map((entity) => entity.id);
        const idsToDownload = entityIds.length > 0 ? entityIds : entities.filter((entity) => entity.id !== 0).map((entity) => entity.id);
        if (idsToDownload.length === 0) {
          console.warn("No entities to download data for");
          setDownloadProgress({
            total: 0,
            completed: 0,
            percentage: 100,
            status: "complete"
          });
          return;
        } else console.log("total entities to download: ", idsToDownload.length, downloadProgress);
        const data = yield s3DataService.downloadPastYearData({
          entityIds: idsToDownload,
          recordType: dataSource,
          onProgress: setDownloadProgress
        });
        if (!data || Object.keys(data).length === 0) {
          console.error("Downloaded data is empty or invalid");
          setDownloadProgress((prev) => __spreadProps(__spreadValues({}, prev), {
            status: "error",
            error: "No data available for the selected criteria"
          }));
          return;
        }
        setDownloadedData(data);
        return data;
      } catch (error) {
        if (error instanceof Error) {
          console.error("Error downloading past year data:", error.message);
        } else {
          console.error("Unknown error occurred");
        }
        setDownloadProgress((prev) => __spreadProps(__spreadValues({}, prev), {
          status: "error",
          error: error instanceof Error ? error.message : "Failed to download data from S3"
        }));
        setDownloadedData(null);
      }
    }),
    [dataSource, downloadProgress.status, entities]
    // Removed downloadProgress.status from dependencies
  );
  const cancelDownload = useCallback(() => {
    setDownloadProgress((prev) => __spreadProps(__spreadValues({}, prev), {
      status: "idle"
    }));
  }, []);
  const dismissError = useCallback(() => {
    setDownloadProgress((prev) => __spreadProps(__spreadValues({}, prev), {
      status: "idle",
      error: void 0
    }));
  }, []);
  useEffect(() => {
    if (!initialLoadAttempted && ["applications", "jobs"].includes(dataSource) && selectedEntities.length > 0) {
      setInitialLoadAttempted(true);
      downloadPastYearData(selectedEntities);
    }
  }, [dataSource, initialLoadAttempted, selectedEntities]);
  useEffect(() => {
    if (initialLoadAttempted && ["applications", "jobs"].includes(dataSource) && selectedEntities.length > 0) {
      downloadPastYearData(selectedEntities);
    }
  }, [selectedEntities, initialLoadAttempted, dataSource, dateRange]);
  const isPieChart = useMemo(
    () => dataSource === "applications" && (groupBy === "source_type" || groupBy === "source"),
    [dataSource, groupBy]
  );
  const chartData = useMemo(() => {
    if (downloadedData && (dataSource === "applications" || dataSource === "jobs")) {
      return transformer(
        dataSource,
        showAs,
        groupBy,
        downloadedData,
        selectedEntities,
        dateRange,
        selectedStatuses
      );
    }
  }, [downloadedData, dataSource, showAs, groupBy, selectedEntities, dateRange, selectedStatuses]);
  const getShowAsOptions = () => {
    if (dataSource === "applications") {
      return [
        { value: "count", label: "Count" },
        { value: "average", label: "Average" }
      ];
    }
    if (dataSource === "jobs" && (downloadedData == null ? void 0 : downloadedData.jobs)) {
      return [
        { value: "count", label: "Count" },
        { value: "average_time", label: "Average Time" }
      ];
    }
    return [
      { value: "count", label: "Count" },
      { value: "average_time", label: "Average Time" }
    ];
  };
  const getGroupByOptions = () => {
    if (dataSource === "applications") {
      if (showAs === "average") {
        return [{ value: "job_reference", label: "Applications per Job" }];
      }
      return [
        { value: "status", label: "Application Status" },
        { value: "source", label: "Source" },
        { value: "source_type", label: "Source Type" }
      ];
    }
    if (dataSource === "jobs") {
      if (showAs === "count") {
        return [
          { value: "location", label: "Location" },
          { value: "internal_external", label: "Internal/External" },
          { value: "job_state", label: "Job State" }
        ];
      }
      if (showAs === "average_time") {
        return [
          { value: "published_to_hired", label: "Job Published date to Hired" },
          {
            value: "first_application_to_hired",
            label: "First Application date to Hired"
          },
          {
            value: "requisition_approved_to_hired",
            label: "Requisition Approved to Hired"
          },
          {
            value: "requisition_requested_to_hired",
            label: "Requisition Requested to Hired"
          }
        ];
      }
    }
    return [];
  };
  const getDateRangeOptions = () => {
    return [
      { value: "last_12_months", label: "Last 12 months" },
      { value: "last_3_months", label: "Last 3 months" },
      { value: "last_month", label: "Last month" },
      { value: "last_year_quarters", label: "Last Year in Quarters" }
    ];
  };
  return {
    state,
    dispatch,
    chartData,
    isPieChart,
    getShowAsOptions,
    getGroupByOptions,
    getDateRangeOptions,
    // Download-related properties and functions
    downloadProgress,
    downloadPastYearData,
    cancelDownload,
    dismissError,
    hasDownloadedData: !!downloadedData,
    availableStatuses
  };
}
